import { createFileRoute, redirect } from "@tanstack/react-router";
import { metadataHead } from "src/lib/Metadata";
import { getAdminAccess } from "src/server/functions/AdminAccess";

// The back office is never indexed.
export const Route = createFileRoute("/_authed/admin")({
  beforeLoad: async () => {
    if (!(await getAdminAccess())) throw redirect({ to: "/portal" });
  },
  head: () => metadataHead({ robots: { index: false, follow: false } }),
});
